var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("\n    Unknow row component : "+_vm._s(_vm.row.type)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }